import React from "react";
import { motion } from "framer-motion";
import { Building2, Radio, Users, Target, Activity, Database, RefreshCw } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { FadeUp, Button, Reveal } from "../components/primitives";
import { Logo } from "../components/Logo";
import { useLang } from "../i18n";

const icons = [Building2, null, Radio, Users, Target, Database, RefreshCw];

const HowItWorks = () => {
  const { t } = useLang();
  const flow = t.howPage.flow;
  return (
    <div className="overflow-hidden">
      <PageHero over={t.howPage.heroOver} title={t.howPage.heroTitle} sub={t.howPage.heroSub} />

      <section className="py-24 md:py-32 bg-white">
        <div className="mx-auto max-w-4xl px-5 md:px-10">
          <div className="relative">
            <div className="absolute left-8 md:left-10 top-0 bottom-0 w-[3px] bg-wanm-offwhite">
              <motion.div className="wanm-gradient-bg w-full origin-top" initial={{ scaleY: 0 }}
                whileInView={{ scaleY: 1 }} viewport={{ once: true }} transition={{ duration: 1.4, ease: "easeInOut" }} />
            </div>
            <div className="space-y-10">
              {flow.map((label, i) => {
                const Icon = icons[i];
                const isWanm = i === 1;
                return (
                  <FadeUp key={i} delay={i * 0.05}>
                    <div className="relative flex items-start gap-6 md:gap-10 pl-0" data-testid={`flow-node-${i}`}>
                      <div className={`relative z-10 w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center shrink-0 ${isWanm ? "bg-white ring-2 ring-wanm-pink/40 shadow-[0_12px_40px_rgba(252,12,201,0.3)]" : "bg-white border-2 border-wanm-offwhite"}`}>
                        {isWanm ? <Logo variant="isotype" height={30} to={false} testId="flow-wanm" />
                          : <Icon className="text-wanm-red" size={30} />}
                      </div>
                      <div className="pt-3">
                        <h3 className={`text-2xl md:text-4xl font-black tracking-tight ${isWanm ? "wanm-gradient-text" : "text-wanm-dark"}`}>{label}</h3>
                        <p className="mt-2 text-lg text-wanm-dark/60 max-w-lg">{t.howPage.flowDesc[i]}</p>
                      </div>
                    </div>
                  </FadeUp>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-wanm-dark text-white text-center">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          <h2 className="text-3xl md:text-5xl font-black tracking-tight leading-tight">
            <Reveal>{t.howPage.heroTitle}</Reveal>
          </h2>
          <div className="mt-10"><Button variant="primary" to="/contact">{t.cta.work}</Button></div>
        </div>
      </section>
    </div>
  );
};

export default HowItWorks;
